import dynaForms from '@elab/core/utils/dynaForms';
import { SHARED_ACTIONS } from '@elab/core/utils/constants';

const getTypes = storeName => ({
    ...dynaForms.getTypes(storeName),
    SET_REGISTRATION_FORM_ID: `${storeName}.SET_REGISTRATION_FORM_ID`,
    SET_REGISTERED_USER: `${storeName}.SET_REGISTERED_USER`,

    CONSENT_NEEDED_DIALOG: `${storeName}.CONSENT_NEEDED_DIALOG`,

    SET_AGE_VERIFICATION: `${storeName}.SET_AGE_VERIFICATION`,
    RESET_AGE_VERIFICATION: `${storeName}.RESET_AGE_VERIFICATION`,

    CHECK_PIN_CODE: `${storeName}.${SHARED_ACTIONS.checkPinCode}`,
    SET_PIN_CODE_STATUS: `${storeName}.${SHARED_ACTIONS.setPinCodeStatus}`,

    SET_STEP: `${storeName}.SET_STEP`,
    REMOVE_PASSWORD_VALIDATION: `${storeName}.REMOVE_PASSWORD_VALIDATION`,
    SET_TEMPORARY_DOB_VALIDATION: `${storeName}.SET_TEMPORARY_DOB_VALIDATION`,
    SET_TEMPORARY_GENDER_VALIDATION: `${storeName}.SET_TEMPORARY_GENDER_VALIDATION`,
    SET_IS_PIN_CODE_OR_DOB_VALID: `${storeName}.${SHARED_ACTIONS.setIsPinCodeOrDOBValid}`,
    PHONE_VERIFICATION_DONE: `${storeName}.PHONE_VERIFICATION_DONE`,
    PHONE_DOB_RECEIVED: `${storeName}.PHONE_DOB_RECEIVED`,
    SHOW_PINCODE: `${storeName}.SHOW_PINCODE`,
    SET_IS_LOYALTY: `${storeName}.SET_IS_LOYALTY`,
    SUBMIT_WITHOUT_PHONE_VERIFICATION: `${storeName}.SUBMIT_WITHOUT_PHONE_VERIFICATION`,
});

export default getTypes;
